// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplicationSetupBody_container__32Zb3","tabsList":"ApplicationSetupBody_tabsList__3gT7o"};